module.exports = __webpack_public_path__ + "static/media/btn_treeFace.249aa394.png";